import React from 'react';
import ChangePassword from '../../components/shared/ChangePassword';

const AdminChangePasswordPage = (props) => <ChangePassword {...props} />;

export default AdminChangePasswordPage;
